import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";

import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";
import { useProviderStatusHistoryStore } from "../store/provider-status-history/providerStatusHistoryStore";

const getOffset = (page, limit) => (Number(page) - 1) * Number(limit);

export default function useProviderStatusHistoryData() {
  const { id } = useParams();
  const providerStatusHistoryRepository = useService("repositories/provider-status-history-repository");
  const { openFailureModal } = getModalHandler();
  const store = useProviderStatusHistoryStore();
  const { currentPage, resLimit, setCurrentPage, setData, setLoading, setResultCount } = store;

  const fetchProviderStatusHistory = useCallback(async () => {
    try {
      setLoading(true);

      const response = await providerStatusHistoryRepository.query({
        providerId: id,
        limit: resLimit,
        offset: getOffset(currentPage, resLimit),
      });
      const count = await providerStatusHistoryRepository.getTotalCount();

      setData(response ?? []);
      setResultCount(count ?? 0);
    } catch (error) {
      console.error(error);
      openFailureModal(error);
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    id,
    openFailureModal,
    providerStatusHistoryRepository,
    resLimit,
    setData,
    setLoading,
    setResultCount,
  ]);

  useEffect(() => {
    fetchProviderStatusHistory();
  }, [fetchProviderStatusHistory]);

  useEffect(() => {
    setCurrentPage(1);
  }, [id, setCurrentPage]);

  return {
    ...store,
    fetchProviderStatusHistory,
  };
}
